import { Box, Button, Divider, Typography } from '@mui/material';
import { LargeIconButton } from '../../layout';
import contractorIcon from '../../../assets/contractor.png';

import { Interweave } from 'interweave';
import { useHistory } from 'react-router-dom';

const MultiTenantForm = ({ lids, llid, landlocation, customisations }) => {
   const history = useHistory();
   const contractorLabel = customisations?.contractorName || 'Contractors';
   const contractorPrompt =
      customisations?.contractorPromptLabel || 'Are you a contractor or service visitor?';
   const tenants = lids.filter(
      (loc) => !(customisations?.hideLandlordCheckin && loc.lid === llid),
   );
   // Balance the rows (6 tenants → 3 + 3, 7 → 4 + 3) so the kiosk fits one iPad screen.
   const perRow = Math.ceil(tenants.length / Math.ceil(tenants.length / 4)) || 1;

   return (
      <Box sx={{ pt: 9, position: 'relative', zIndex: 1, pb: 2 }}>
         {customisations !== null && customisations.welcomeTitle !== '' ? (
            <Typography align="center" variant="h5" component="h1" color="primary">
               {customisations.welcomeTitle}
            </Typography>
         ) : (
            <Typography align="center" variant="h5" component="h1" color="primary">
               Who are you visiting?
            </Typography>
         )}
         {customisations !== null &&
            customisations.welcomeMessage !== '' &&
            customisations.welcomeMessage !== '<p><br></p>' && (
               <Box
                  sx={{
                     mt: 1,
                     px: 1.5,
                     py: 0.25,
                     border: '1px solid #ccc',
                     borderRadius: 2,
                     backgroundColor: '#fff',
                     '& p': { my: 0.25 },
                  }}
               >
                  <Interweave content={customisations.welcomeMessage} />
               </Box>
            )}
         <Box
            sx={{
               display: 'flex',
               justifyContent: 'center',
               flexWrap: 'wrap',
               mt: 0.5,
               maxWidth: perRow * 266, // 250px tile + 8px margin each side
               mx: 'auto',
            }}
         >
            {tenants.map((loc) => (
               <LargeIconButton
                  key={loc.lid}
                  title={loc.displayName}
                  icon={loc.logoPath}
                  phone={loc.phone}
                  onClick={() => {
                     history.push({
                        pathname: `/visitors?llid=${llid}&llocation=${landlocation}&loc=${loc.lid}&locName=${loc.displayName}`,
                     });
                     history.go(0);
                  }}
               />
            ))}
         </Box>
         {customisations?.contractorCheckIn && (
            <Box sx={{ mt: 2, maxWidth: 720, mx: 'auto', px: 2 }}>
               <Divider sx={{ mb: 1.5 }}>
                  <Typography variant="subtitle1" color="text.secondary">
                     {contractorPrompt}
                  </Typography>
               </Divider>
               <Button
                  variant="outlined"
                  fullWidth
                  onClick={() => {
                     history.push({
                        pathname: `/visitors?llid=${llid}&llocation=${landlocation}&loc=${llid}&locName=${landlocation}&contractor=true`,
                     });
                     history.go(0);
                  }}
                  sx={{
                     height: 64,
                     backgroundColor: '#fff',
                     borderRadius: 2,
                     justifyContent: 'center',
                     gap: 2,
                     fontSize: 'large',
                     textTransform: 'none',
                     '&:hover': { backgroundColor: '#f0f0f0' },
                  }}
               >
                  <Box
                     component="img"
                     src={contractorIcon}
                     alt=""
                     sx={{ height: 36, width: 'auto' }}
                  />
                  {contractorLabel}
               </Button>
            </Box>
         )}
      </Box>
   );
};

export default MultiTenantForm;
